import { gql } from '@apollo/client';

export const FETCH_APP_DATA = gql`
    query FetchAppData($versionStatus: VersionStatusType) {
        glassesPackages(
            company: PNL
            glassesType: REGULAR
            versionStatus: $versionStatus
        ) {
            id
            name
            default
            multifocal
            borderless
            backgroundColorGeneral
            textColorGeneral
            priceInt
            discountPercentage
            canBeOrdered
            order
            topChoice
            featureIds
            addOns {
                id
                name
                description
                order
                priceInt
                excludesAddOnIds
                freeWithPackagesIds
            }
        }
        features(
            company: PNL
            glassesType: REGULAR
            versionStatus: $versionStatus
        ) {
            id
            name
            order
            multifocalOnly
        }
    }
`;
